import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useNavigate } from "react-router-dom";

const StepSuccess = ({ onGoToLogin }) => {
    const navigate = useNavigate();
  return (
    <div className="fp-step fp-step--success">
      <div className="fp-success-icon">
        <CheckCircle2 size={48} />
      </div>
      <h3 className="fp-step__title">Password Reset!</h3>
      <p className="fp-step__sub">Your password has been changed successfully. You can now log in with your new password.</p>

       <button
      className="fp-btn-primary"
      onClick={() => navigate("/")}
    >
      Back to Home
    </button>
    </div>
  );
};

export default StepSuccess;